module.exports = function getResource(label, vars = []) {
    const resources = {
        pickupPerson: 'Pickup Person',
        pleaseHaveYour: 'Please have your ',
        photoId: 'photo ID ',
        addedInstructions: 'ready when you retrieve your order. Packages will be held for up-to 5 days before being returned to us.'
    };

    return resources[label];
};
